import { MCPTTProvider } from "./mcptt/MCPTTProvider";
import { useConnectionState } from "./mcptt/hooks";
import { Login } from "./components/Login";
import { Connecting } from "./components/Connecting";
import { Shell } from "./components/Shell";

/**
 * App top-level — picks one of three states based on connection lifecycle:
 *
 *   - Login screen     while disconnected/error/reconnecting (and no
 *                      successful login yet)
 *   - Connecting       during configuring/logging-in/initializing
 *   - Shell            once ready
 */
export function App() {
  return (
    <MCPTTProvider>
      <Router />
    </MCPTTProvider>
  );
}

function Router() {
  const state = useConnectionState();

  switch (state) {
    case "ready":
      return <Shell />;
    case "configuring":
    case "logging-in":
    case "initializing":
      return <Connecting status={connectStatusLabel(state)} />;
    case "connecting":
      return <Connecting status="OPENING SOCKET" />;
    case "reconnecting":
      return <Connecting status="RECONNECTING" />;
    case "disconnected":
    case "error":
    default:
      return <Login />;
  }
}

function connectStatusLabel(s: "configuring" | "logging-in" | "initializing"): string {
  if (s === "configuring")  return "NEGOTIATING CONFIG";
  if (s === "logging-in")   return "AUTHENTICATING";
  return "LOADING ROSTER";
}
